import React from 'react';
import { browserHistory } from 'react-router';
import './UserProductSales.scss';
import dayjs from 'dayjs';
class UserProductSales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'revenue', // 'revenue' or 'ranking'
      currentPage: 1,
      pageSize: 10,
    };
  }

  componentDidMount() {
    const { auth } = this.props;
    const token = auth && auth.token;
    if (!token) return;

    this.fetchAllData(1, token);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage) {
      const { auth } = this.props;
      const token = auth && auth.token;
      if (!token) return;
      this.fetchOrdersForPage(this.state.currentPage, token);
    }
  }

  fetchAllData = (pageNum, token) => {
    const search = ',';
    const filter = JSON.stringify({});
    const sorting = JSON.stringify({});
    const exactMatch = 0;

    this.props.getRecomSaleProductStatis(token);
    this.props.getRecomSaleProductRank(token);
    this.props.getRecomSaleProductOrders(pageNum, search, filter, sorting, token, exactMatch);
  }

  fetchOrdersForPage = (pageNum, token) => {
    const search = ',';
    const filter = JSON.stringify({});
    const sorting = JSON.stringify({});
    const exactMatch = 0;

    this.props.getRecomSaleProductOrders(pageNum, search, filter, sorting, token, exactMatch);
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab, currentPage: 1 });
  }

  handlePageChange = (direction) => {
    const { currentPage } = this.state;
    if (direction === 'prev' && currentPage > 1) {
      this.setState({ currentPage: currentPage - 1 });
    } else if (direction === 'next') {
      this.setState({ currentPage: currentPage + 1 });
    }
  }

  handleViewDetails = (productId) => {
    browserHistory.push(`/buy-cdk/${productId}`);
  }

  renderStatsCards = () => {
    const { user } = this.props;
    const stats = user && user.recomSaleProductStatistics && user.recomSaleProductStatistics.data;

    let statsData;
    if (stats) {
      console.log(stats);
      const todayEarings = stats.todayEarings || 0;
      const monthEarings = stats.monthEarings || 0;
      const lastMonthEarings = stats.lastMonthEarings || 0;
      const totalEarings = stats.totalEarings || 0;
      const todayOrders = stats.todayOrders || 0;
      const monthOrders = stats.monthOrders || 0;
      const lastMonthOrders = stats.lastMonthOrders || 0;
      const totalOrders = stats.totalOrders || 0;
      const yesterdayEarings = stats.yesterdayEarings !== undefined && stats.yesterdayEarings !== null ? stats.yesterdayEarings : null;
      const yesterdayOrders = stats.yesterdayOrders !== undefined && stats.yesterdayOrders !== null ? stats.yesterdayOrders : null;

      const formatNumber = (num) =>
        typeof num === 'number' ? num.toLocaleString(undefined, { maximumFractionDigits: 2 }) : num;

      const calcChange = (current, last, label = 'last month') => {
        if (last === undefined || last === null) return null;
        
        // 如果上期是0
        if (last === 0) {
          // 如果当前也是0，显示N/A
          if (current === 0) {
            return { text: `N/A vs ${label}`, status: 'neutral' };
          }
          // 如果当前大于0，从0到有值，显示为100%增长
          return {
            text: `100.0% vs ${label}`,
            status: 'positive',
          };
        }
        
        const diff = ((current - last) / last) * 100;
        const absDiff = Math.abs(diff);
        
        // 如果变化小于 0.1%，视为持平
        if (absDiff < 0.1) {
          return {
            text: `0.0% vs ${label}`,
            status: 'neutral',
          };
        }
        
        return {
          text: `${absDiff.toFixed(1)}% vs ${label}`,
          status: diff >= 0 ? 'positive' : 'negative',
        };
      };

      // 计算上月平均每日数据（假设每月30天）

      // 计算各指标的对比
      const todayEarningChange = calcChange(todayEarings, yesterdayEarings, 'Yesterday');
      const totalEarningChange = calcChange(totalEarings, lastMonthEarings, 'Last month');
      const earningChange = calcChange(monthEarings, lastMonthEarings, 'Last month');
      const todayOrderChange = calcChange(todayOrders, yesterdayOrders, 'Yesterday');
      const orderChange = calcChange(monthOrders, lastMonthOrders,'Same period last month');
      const totalOrderChange = calcChange(totalOrders, lastMonthOrders, 'Previous month');

      statsData = [
        {
          title: "Today's Earnings (USDO)",
          value: formatNumber(todayEarings),
          icon: 'fa-jpy',
          iconBackgroundColor: 'rgba(17, 68, 206, 0.2)',
          iconColor: 'rgb(17, 68, 206)',
          change: todayEarningChange ? todayEarningChange.text : null,
          changeStatus: todayEarningChange ? todayEarningChange.status : 'neutral',
        },
        {
          title: 'Total Commission (USDO)',
          value: formatNumber(totalEarings),
          icon: 'fa-line-chart',
          iconBackgroundColor: 'rgba(118, 98, 231, 0.2)',
          iconColor: 'rgb(118, 98, 231)',
          change: totalEarningChange ? totalEarningChange.text : null,
          changeStatus: totalEarningChange ? totalEarningChange.status : 'neutral',
        },
        {
          title: "This month's earnings (USDO)",
          value: formatNumber(monthEarings),
          change: earningChange ? earningChange.text : null,
          changeStatus: earningChange ? earningChange.status : 'neutral',
          icon: 'fa-calendar',
          iconBackgroundColor: 'rgba(55, 239, 116, 0.2)',
          iconColor: 'rgb(55, 239, 116)',
        },
        {
          title: "Today's order count",
          value: String(todayOrders),
          centered: true,
          change: todayOrderChange ? todayOrderChange.text : null,
          changeStatus: todayOrderChange ? todayOrderChange.status : 'neutral',
        },
        {
          title: "This month's order count",
          value: String(monthOrders),
          change: orderChange ? orderChange.text : null,
          changeStatus: orderChange ? orderChange.status : 'neutral',
          centered: true,
        },
        {
          title: 'Total Orders',
          value: String(totalOrders),
          centered: true,
          change: totalOrderChange ? totalOrderChange.text : null,
          changeStatus: totalOrderChange ? totalOrderChange.status : 'neutral',
        },
      ];
    } else {
      // 无数据时直接返回空，不再使用 mock
      return null;
    }

    return (
      <div className="stats-cards-grid">
        {statsData.map((stat, index) => (
          <div key={index} className={`stats-card ${stat.centered ? 'centered' : ''}`}>
            <div className="stats-title">
              <div className="stats-title-text">{stat.title}</div>
              {stat.icon && <div className="stats-title-icon" style={{ backgroundColor: stat.iconBackgroundColor }}>
                <i className={`fa ${stat.icon}`} style={{ color: stat.iconColor }} />
              </div>}
            </div>
            <div className="stats-value">{stat.value}</div>
            {stat.change && (
              <div className={`stats-change ${stat.changeStatus || 'neutral'}`}>
                {stat.changeStatus === 'positive' && <i className="fa fa-arrow-up" />}
                {stat.changeStatus === 'negative' && <i className="fa fa-arrow-down" />}
                {stat.changeStatus === 'neutral' && <i className="fa fa-minus" />}
                <span>{stat.change}</span>
              </div>
            )}
            {stat.status && (
              <div className="stats-status">{stat.status}</div>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderRevenueDetails = () => {
    const { user } = this.props;
    const { currentPage } = this.state;

    const saleProductOrders = user && user.saleProductOrders;
    const records = (saleProductOrders && saleProductOrders.data) || [];
    const pagination = (saleProductOrders && saleProductOrders.pagination) || {};

    const totalPages = pagination.totalPages || 1;
    const totalRecords = pagination.totalUsers || records.length;

    return (
      <div className="table-wrapper">
        <table className="sales-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Product Information</th>
              <th>Revenue Amount <br />(USDO)</th>
              <th>Commission Rate</th>
              <th>Sales Time</th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data-cell">
                  No data
                </td>
              </tr>
            ) : (
              records.map((item) => {
                const orderTime = item.orderTime ? dayjs(item.orderTime).format('YYYY-MM-DD HH:mm:ss') : '';
                const cover = item.product.cover;
                const commissionRate = item.product.commission;


                return (
                  <tr key={item.orderId}>
                    <td data-label="Order ID">{item.orderId}</td>
                    <td className="product-info-cell" data-label="Product Information">
                      <div className="product-info">
                        <img src={cover} alt={item.productName} className="product-thumbnail" />
                        <div className="product-details">
                          <div className="product-name">{item.productName}</div>
                          <div className="product-id">id: {item.product?._id}</div>
                        </div>
                      </div>
                    </td>
                    <td className="revenue-amount" data-label="Revenue Amount (USDO)">
                      {(item.balance * (commissionRate / 100)).toFixed(2) || 0}
                    </td>
                    <td data-label="Commission Rate">{commissionRate}%</td>
                    <td className="sales-time" data-label="Sales Time">
                      <div className="time-date">{orderTime}</div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>

        <div className="pagination">
          <div className="pagination-left">
            <span className="regular_title">RECORDS: {totalRecords} (Page {currentPage} of {totalPages})</span>
          </div>
          <div className="pagination-right">
            <button
              className="regular"
              onClick={() => this.handlePageChange('prev')}
              disabled={currentPage === 1}
            >
              <i className="fa fa-caret-left fa-2x" />
            </button>
            <button
              className="regular"
              onClick={() => this.handlePageChange('next')}
              disabled={currentPage >= totalPages}
            >
              <i className="fa fa-caret-right fa-2x" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderSalesRanking = () => {
    const { currentPage, pageSize } = this.state;
    const { user } = this.props;

    const rankState = user && user.recomSaleProductRank;
    const rankData = (rankState && rankState.data) || [];

    const totalPages = Math.max(1, Math.ceil(rankData.length / pageSize));
    const totalRecords = rankData.length;
    const startIndex = (currentPage - 1) * pageSize;
    const displayedData = rankData.slice(startIndex, startIndex + pageSize);

    return (
      <div className="table-wrapper">
        <table className="sales-table">
          <thead>
            <tr>
              <th>Product Information</th>
              <th>Revenue Amount <br />(USDO)</th>
              <th>Commission Rate</th>
              <th>Sales Amount</th>
              <th>Sales Quantity</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {displayedData.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data-cell">
                  No data
                </td>
              </tr>
            ) : (
              displayedData.map((item) => (
                <tr key={item.productId}>
                  <td className="product-info-cell" data-label="Product Information">
                    <div className="product-info">
                      <img src={item.product.cover} alt={item.product.name} className="product-thumbnail" />
                      <div className="product-details">
                        <div className="product-name">{item.product.name}</div>
                        <div className="product-id">{item.product.id}</div>
                      </div>
                    </div>
                  </td>
                  <td className="revenue-amount" data-label="Revenue Amount (USDO)">{item.total * (item.product.commission / 100).toFixed(2) || 0}</td>
                  <td data-label="Commission Rate">{item.product.commission}%</td>
                  <td data-label="Sales Amount">{item.total}</td>
                  <td data-label="Sales Quantity">{item.count}</td>
                  <td data-label="Action">
                    <button
                      className="action-btn view-details"
                      onClick={() => this.handleViewDetails(item.product.id)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination">
          <div className="pagination-left">
            <span className="regular_title">RECORDS: {totalRecords} (Page {currentPage} of {totalPages})</span>
          </div>
          <div className="pagination-right">
            <button
              className="regular"
              onClick={() => this.handlePageChange('prev')}
              disabled={currentPage === 1}
            >
              <i className="fa fa-caret-left fa-2x" />
            </button>
            <button
              className="regular"
              onClick={() => this.handlePageChange('next')}
              disabled={currentPage >= totalPages}
            >
              <i className="fa fa-caret-right fa-2x" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { activeTab } = this.state;

    return (
      <div className="user-product-sales-wrapper">
        <div className="user-product-sales">
          <div className="page-header">
            <h1 className="page-title">Product Sales</h1>
          </div>

          <div className="section-header">
            <i className="fa fa-tachometer fa-2x" />
            <h2 className="section-title">Core Data Overview</h2>
          </div>
          {this.renderStatsCards()}
          <div className="tabs-container">
            <div className="tabs">
              <button
                className={`tab ${activeTab === 'revenue' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('revenue')}
              >
                Revenue Details
              </button>
              <button
                className={`tab ${activeTab === 'ranking' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('ranking')}
              >
                Sales Ranking
              </button>
            </div>
          </div>
          {activeTab === 'revenue' ? this.renderRevenueDetails() : this.renderSalesRanking()}
        </div>
      </div>
    );
  }
}

export default UserProductSales;
